import * as apiUtil from '@apps-common/js-client/api/util';

export function getUrl({item, size, token}) {
  const url = item._links?.thumbnail;
  if (!url) {
    return;
  }

  return apiUtil.addQueryParams(url, {
    width: size || 256,
    token: token,
  });
}
